﻿import { NotEmpty } from "@/helpers/Misc";
export class XmlHelper {
  public static stringToXmlDocument(xmlString: string): XMLDocument | null {
    if (typeof window["DOMParser"] != "undefined") {
      return new window["DOMParser"]().parseFromString(xmlString, "text/xml") as XMLDocument;
    } else if (typeof window["ActiveXObject"] != "undefined") {
      var xmlDoc = new window["ActiveXObject"]("Microsoft.XMLDOM");
      if (xmlDoc) {
        xmlDoc.async = "false";
        xmlDoc.loadXML(xmlString);
        return xmlDoc as XMLDocument;
      }
    } else {
      throw new Error("No XML parser found");
    }
    return null;
  }
  public static newXMLDocument(): XMLDocument | null {
    if (typeof window["DOMParser"] != "undefined") {
      return new window["DOMParser"]().parseFromString("", "text/xml") as XMLDocument;
    } else if (typeof window["ActiveXObject"] != "undefined") {
      var xmlDoc = new window["ActiveXObject"]("Microsoft.XMLDOM");
      if (xmlDoc) {
        xmlDoc.async = "false";
        xmlDoc.loadXML("");
        return xmlDoc as XMLDocument;
      }
    }
    return null;
  }

  public static mapToObject(xml: Element) {
    const children = Array.from(xml.children);
    let object = {} as any;
    for (let i = 0; i < children.length; i++) {
      let child = children[i] as Element;
      if (child) {
        console.log(child, child.children.length);
        if (child.children.length > 1) {
          if (!object[child.nodeName as string]) {
            object[child.nodeName as string] = [];
          }
          object[child.nodeName as string].push(this.mapToObject(child));
        } else {
          object[child.nodeName as string] = child.textContent;
        }
      }
    }
    return object;
  }

  public static xmlToObject(xml: any): any {
    try {
      var obj = {} as any;
      if (xml.children.length > 0) {
        for (var i = 0; i < xml.children.length; i++) {
          var item = xml.children.item(i);
          var nodeName = item.nodeName as string;
          if (obj[nodeName]) {
            if (typeof obj[nodeName] == "undefined") {
              obj[nodeName] = XmlHelper.xmlToObject(item);
            } else {
              if (typeof obj[nodeName].push == "undefined") {
                var old = obj[nodeName];

                obj[nodeName] = [];
                obj[nodeName].push(old);
              }
              obj[nodeName].push(XmlHelper.xmlToObject(item));
            }
          }
        }
      } else {
        obj = xml.textContent;
      }
      return obj;
    } catch (e: any) {
      console.error(e.message);
    }
  }

  public static getNormalizedXpath(xpath: string): string {
    //get rid of '/' at the start
    if (xpath.startsWith("/")) {
      xpath = xpath.substring(1);
    }
    //get rid of '/' at the end
    if (xpath.endsWith("/")) {
      xpath = xpath.substring(0, xpath.length - 1);
    }

    //get rid of attributes in []
    //xpath = XmlHelper.removeXpathMetaData(xpath);

    xpath = XmlHelper.removeXpathMetaData(xpath, true);

    //we are searching for xpathNodeName/ to avoid cases like finding "Attachments" when looking for "Attachment" substring
    return xpath + "/";
  }

  public static compareNamespaces() {}

  public static getXpathImportSelector(xpath: string) {
    //get rid of '/' at the end
    if (xpath.endsWith("/")) {
      xpath = xpath.slice(0, -1);
    }
    xpath = this.formatXpath(xpath);

    return xpath.replace(/\//g, " > ");
  }

  public static formatXpath(xpath: string): string {
    if (xpath.includes("@") && !xpath.includes("'@'")) {
      xpath = xpath.replace(/@/g, "");
      xpath = xpath.replace(/ and /g, "][");
    }
    var matchChild = xpath.match(/\[[0-9]+\]/);
    if (matchChild !== null) {
      xpath = xpath.replace(/\[[0-9]+\]/g, function (match, offset, string) {
        var replacement = ":nth-of-type(" + match.slice(1, -1) + ")";
        //var replacement = ">" + match.slice(1, -1) + "";
        //var replacement=  "";
        return replacement;
      });
    } else {
      xpath = XmlHelper.removeXpathMetaData(xpath);
    }
    return xpath;
  }

  public static getParentElementXpath(xpath: string) {
    //get rid of '/' at the end
    if (xpath.endsWith("/")) {
      xpath = xpath.slice(0, -1);
    }
    return xpath.substring(0, xpath.lastIndexOf("/"));
  }

  public static getXpathSinceSegment(xpath: string, segment: string): string {
    // +1 to remove "/" at the start, -1 to remove "/" at the end
    return xpath.substring(xpath.indexOf("/" + segment) + 1, xpath.length - 1);
  }

  public static removeXpathMetaData(xpath: string, keepAttributes: boolean = false) {
    if (keepAttributes && xpath.includes("@")) {
      return xpath.replace(/\[[^@]*]/gm, "");
    }
    /*else {
            return xpath.replace(/\[[^\]]*]/gm, '');
        } */
    return xpath;
  }

  public static clearChildren(element: Element) {
    while (element.firstChild) element.removeChild(element.lastChild as Node);
  }

  public static removeChild(nodeToRemove: string, parentNode: Element): void {
    let element = parentNode.querySelector(nodeToRemove);
    if (element) {
      parentNode.removeChild(element);
    }
  }

  // public static getControlSelector(control: IControl, parentTableXpath: string, xmlNodeName: string) {
  //   let selector = control.xpathImportSelector;
  //   if (parentTableXpath) {
  //     let xpathSubstring = control.normalizedXpath.replace(parentTableXpath, "");
  //     if (xpathSubstring.startsWith("/")) {
  //       xpathSubstring = xpathSubstring.slice(1, xpathSubstring.length);
  //     }

  //     if (xpathSubstring === "") {
  //       selector = control.xpathNodeName;
  //     } else {
  //       selector = xmlNodeName + " > " + XmlHelper.getXpathImportSelector(xpathSubstring);
  //     }
  //   }
  //   return selector;
  // }

  public static getParentSelectorBySelector(selector: string, parentlevel?: number): string {
    let parentSegments = selector.split(">");

    if (!parentlevel) {
      parentlevel = 1;
    }

    for (let ii = 0; ii < parentlevel; ii++) {
      parentSegments.pop();
    }
    let importedXmlParentSelector = parentSegments.join(" > ").trim();
    return importedXmlParentSelector;
  }

  public static replaceElementWithElements(existing: Element, elementsToReplace: Array<Element>) {
    if (elementsToReplace.length === 1) {
      existing.replaceWith(elementsToReplace[0]);
    }
    if (elementsToReplace.length > 1) {
      let referenceNode = elementsToReplace[0];
      existing.replaceWith(referenceNode);
      for (let i = 1; i < elementsToReplace.length; i++) {
        let duplicate = elementsToReplace[i];
        if (referenceNode.parentElement) {
          referenceNode.parentElement.insertBefore(duplicate, referenceNode.nextSibling);
          referenceNode = duplicate;
        }
      }
    }
  }

  public static formatEmailExport(xml: Element) {
    let emails = Array.from(xml.querySelectorAll("InternetAddress"));
    for (let elem of emails) {
      if (elem.childElementCount > 0) {
        let addresses = Array.from(elem.querySelectorAll("Address"));
        for (let address of addresses) {
          XmlHelper.prependString("mailto:", address);
        }
      } else {
        XmlHelper.prependString("mailto:", elem);
      }
    }
  }

  public static formatEmailImport(xml: Element) {
    let emails = Array.from(xml.querySelectorAll("InternetAddress"));
    for (let elem of emails) {
      if (elem.childElementCount > 0) {
        let addresses = Array.from(elem.querySelectorAll("Address"));
        for (let address of addresses) {
          if (address.textContent) address.textContent = address.textContent.replace("mailto:", "");
        }
      } else {
        if (elem.textContent) elem.textContent = elem.textContent.replace("mailto:", "");
      }
    }
  }

  private static prependString(prefix: string, element: Element) {
    if (element.textContent) {
      element.textContent = prefix + element.textContent;
    }
  }

  public static removeXmlElementsIfEmpty(element: Element) {
    const children = Array.from(element.children);
    for (let i = 0; i < children.length; i++) {
      this.removeXmlElementsIfEmpty(children[i]);
    }

    const emptyElement = element.children.length === 0;
    if (element) {
      const emptyText = (element.textContent as string).trim() === "";
      if (emptyElement && emptyText) {
        if (element.parentElement) {
          element.parentElement.removeChild(element);
        }
      }
    }
  }

  public static checkXmlElementsIfEmpty(element: Element | any[]) {
    let empty = true;
    if (Array.isArray(element)) {
      if (element.length > 0) {
        for (let j = 0; j < element.length; j++) {
          let temp = this.checkXmlElementsIfEmpty(element[j]);
          if (!temp) {
            empty = false;
          }
        }
      }
    } else {
      const children = Array.from(element.children);

      if (children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          let temp = this.checkXmlElementsIfEmpty(children[i]);
          if (!temp) {
            empty = false;
          }
        }
      } else {
        const emptyElement = element.children.length === 0;
        if (element) {
          const emptyText = (element.textContent as string).trim() === "";
          if (emptyElement && emptyText) {
            return true;
          } else {
            return false;
          }
        }
      }
    }
    return empty;
  }
  public static setElementValue(parentElement: Element, elementSelector: string, value: string) {
    if (!elementSelector) {
      console.log("Set element value went somewhere wrong", parent, elementSelector, value);
    }
    let tempElement = parentElement.querySelector(elementSelector);

    if (tempElement) {
      tempElement.textContent = value;
    } else {
      console.log("Element with selector was not found => ", elementSelector, value);
    }
  }
  public static removeMetadataFromXML(xml: Element) {
    let tableTemplateElements = xml.querySelectorAll("[class~='dont-export']");
    tableTemplateElements.forEach((node) => node.parentNode?.removeChild(node));

    xml.removeAttribute("notInFormData");

    let notInFormDataElements = Array.from(xml.querySelectorAll("[notInFormData]"));
    for (let elem of notInFormDataElements) {
      elem.removeAttribute("notInFormData");
    }

    let emptyFormElements = Array.from(xml.querySelectorAll("[emptyForm]"));
    for (let elem of emptyFormElements) {
      elem.removeAttribute("emptyForm");
    }
  }
}
